import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Send extends Bloc {

	constructor (src, ctx) {

		super("send", src, ctx, true);
		this.f = (src, ins) => {
			const former = ins[0].location;
			ins[0].goto(ins[1]);
			if (former === src.master.exile && (ins[1] === src.master.deck || ins[1] === src.master.supply || ins[1] === src.master.discard))
				src.master.notify("shufflecard", ins[0], ins[1]);
			return [];
		};
		this.types = [Types.card, Types.location];
	}
}